import React from 'react';

import { Cell, List } from 'ui-builder';
import { GridLayout, GridLayoutTheme, Accordion } from 'features/nekst-widgets';
import { DetailFieldName, TextFieldValue } from './DetailFieldCells';
import { ProjectDetailFieldRow } from './types';
import EditableFieldCell from './EditableFieldCell';

export default function InformationFieldsBlock(props: { fields: ProjectDetailFieldRow[] }) {
  return (
    <Accordion
      title="Information"
      count={props.fields.length}
      defaultOpen
      sectionId="information"
      pageContext="transaction-detail"
    >
      <List
        getDataFunc={async () => props.fields}
        dependencies={[JSON.stringify(props.fields)]}
      >
        <GridLayout
          theme={GridLayoutTheme.LIGHT}
          weights={[1, 1]}
          noDataMessage="No information fields."
        >
          <Cell label="Detail" isCentered={false}>
            <DetailFieldName />
          </Cell>
          <Cell label="Value" isCentered={false}>
            <EditableFieldCell>
              <TextFieldValue />
            </EditableFieldCell>
          </Cell>
        </GridLayout>
      </List>
    </Accordion>
  );
}
